import React from "react";
import styled from "styled-components";
import Rheostat from "rheostat";

const Question = styled.div`
  font-family: Lato;
  font-size: 18px;
  line-height: 22px;
  color: #000;
  margin-top: 30px;
`;

const SliderButton = props => (
  <button {...props} type="button">
    {props["aria-valuenow"]}
  </button>
);

const TextareaFeedback = styled.textarea`
  display: block;
  padding: 10px;
  width: 100%;
  height: 130px;
  background: #fff;
  border: 1px solid #857e7e;
  resize: none;
  margin-top: 10px;
  outline: none;
  font-family: Lato;
  font-size: 14px;
  color: #222;
  line-height: 1.2;

  &:focus {
    outline: none;
  }
`;

const ErrorMessage = styled.div`
  font-family: Lato;
  font-style: italic;
  font-size: 14px;
  color: #ff0000;
`;

const ErrorMessageFeedback = styled(ErrorMessage)`
  margin-top: 10px;
`;

const ErrorMessageRating = styled(ErrorMessage)`
  margin-top: 20px;
  text-align: center;
`;

const CharsCounter = styled.div`
  font-family: Lato;
  font-size: 14px;
  line-height: 14px;
  color: #bdbdbd;
  text-align: right;
  margin-top: -14px;

  ${p =>
    p.countOfWords < 10 &&
    `
    span {
      color: #f00;
    }
  `}

  ${p =>
    p.countOfWords > 200 &&
    `
    span {
      color: #f00;
    }
  `}
`;

const RadioFieldRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 15px;

  label {
    font-family: Lato;
    font-weight: normal;
    font-size: 18px;
    line-height: 20px;
    color: #000;
    margin: 0;
    padding: 0;
    cursor: pointer;
  }

  input[type="radio"] {
    width: 20px;
    height: 20px;
    margin: 0 15px;
    cursor: pointer;
  }
`;

const getCountOfWords = str => {
  str = str.replace(/(^\s*)|(\s*$)/gi, '');
  str = str.replace(/[ ]{2,}/gi, ' ');
  str = str.replace(/\n /, "\n");

  return str.split(' ').filter(w => w !== '').length;
}

const FeedbackResponseComponent = ({
  questions,
  questionsOffset,
  setAnswer,
  getAnswer,
  showErrors,
  getError,
  teammates,
  readonly_mode = false,
}) => (
  <div>
    {questions &&
      questions.length > 0 &&
      questions.map((question, i) => {
        const answer = getAnswer(question.id);
        const error = getError(question.id);

        if (question.answer_type === "rating") {
          return (
            <div key={question.id}>
              <Question>
                {i + questionsOffset + 1}. {question.text}
              </Question>
              <Rheostat
                className="feedback-rheostat"
                min={0}
                max={7}
                snap={true}
                handle={SliderButton}
                values={[answer.answer_text ? answer.answer_text : 0]}
                onChange={obj => readonly_mode ? () => {} : setAnswer(question.id, obj.values[0])}
                disabled={readonly_mode}
              />
              {showErrors === true && error && (
                <ErrorMessageRating>{error}</ErrorMessageRating>
              )}
            </div>
          );
        }

        if (
          question.answer_type === "freeform" &&
          question.text !==
            "Besides yourself, who is the most valuable person on your team?" &&
          question.text !==
            "Besides yourself, who was the most valuable person on your team?" &&
          question.text !== "Would you want to work with this teammate again?"
        ) {
          const countOfWords = answer.answer_text
            ? getCountOfWords(answer.answer_text)
            : 0;

          return (
            <div key={question.id}>
              <Question>
                {i + questionsOffset + 1}. {question.text}
              </Question>
              {!readonly_mode &&
              <CharsCounter countOfWords={countOfWords}>
                <span>{countOfWords}</span> / 200
              </CharsCounter>}
              <TextareaFeedback
                value={answer.answer_text ? answer.answer_text : ""}
                onChange={e => readonly_mode ? () => {} : setAnswer(question.id, e.target.value)}
                readOnly={readonly_mode}
              />
              {showErrors === true && error && (
                <ErrorMessageFeedback>{error}</ErrorMessageFeedback>
              )}
            </div>
          );
        }

        if (
          question.text ===
            "Besides yourself, who is the most valuable person on your team?" ||
          question.text ===
            "Besides yourself, who was the most valuable person on your team?"
        ) {
          return (
            <div key={question.id}>
              <Question>
                {i + questionsOffset + 1}. {question.text}
              </Question>
              {teammates.map(({ user }) => (
                <RadioFieldRow key={user.id}>
                  <input
                    type="radio"
                    id={`selectTeamMember${user.id}`}
                    value={user.username}
                    name="selectTeamMember"
                    checked={
                      answer.answer_text
                        ? user.username === answer.answer_text
                          ? true
                          : false
                        : false
                    }
                    onChange={() => readonly_mode ? () => {} : setAnswer(question.id, user.username)}
                    disabled={readonly_mode}
                  />
                  <label htmlFor={`selectTeamMember${user.id}`}>
                    {user.first_name} {user.last_name}
                  </label>
                </RadioFieldRow>
              ))}
              {showErrors === true && error && (
                <ErrorMessageFeedback>{error}</ErrorMessageFeedback>
              )}
            </div>
          );
        }

        if (
          question.text === "Would you want to work with this teammate again?"
        ) {
          return (
            <div key={question.id}>
              <Question>
                {i + questionsOffset + 1}. {question.text}
              </Question>
              <RadioFieldRow>
                <input
                  type="radio"
                  id={`select${question.id}_yes`}
                  value="yes"
                  name={`select${question.id}`}
                  checked={
                    answer.answer_text
                      ? "yes" === answer.answer_text
                        ? true
                        : false
                      : false
                  }
                  onChange={() => readonly_mode ? () => {} : setAnswer(question.id, "yes")}
                  disabled={readonly_mode}
                />
                <label htmlFor={`select${question.id}_yes`}>Yes</label>
              </RadioFieldRow>
              <RadioFieldRow>
                <input
                  type="radio"
                  id={`select${question.id}_no`}
                  value="no"
                  name={`select${question.id}`}
                  checked={
                    answer.answer_text
                      ? "no" === answer.answer_text
                        ? true
                        : false
                      : false
                  }
                  onChange={() => readonly_mode ? () => {} : setAnswer(question.id, "no")}
                  disabled={readonly_mode}
                />
                <label htmlFor={`select${question.id}_no`}>No</label>
              </RadioFieldRow>
              {showErrors === true && error && (
                <ErrorMessageFeedback>{error}</ErrorMessageFeedback>
              )}
            </div>
          );
        }

        return null;
      })}
  </div>
);

export default FeedbackResponseComponent;



// WEBPACK FOOTER //
// ./src/components/quiz/feedbackResponse.js